import { SubmitHandler, useForm } from "react-hook-form";
import { useContext } from "react";
import { IconBug, IconCheck, IconSend2 } from "@tabler/icons-react";
import TextArea from "../../core/TextArea.tsx";
import Conditional from "../../core/Conditional.tsx";
import { SubmitContext } from "../../../context/context.submit";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";

export type MessageFormType = {
  chatMessage: string;
};
const MessageForm = ({
  onSubmit,
  placeholder,
}: {
  onSubmit: SubmitHandler<MessageFormType>;
  placeholder?: string;
}) => {
  const { initSubmit, finishSubmit, loading, setButtonElem } =
    useContext(SubmitContext);
  const messageForm = useForm<MessageFormType>({
    defaultValues: {
      chatMessage: "",
    },
    mode: "all",
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = messageForm;
  const submit: SubmitHandler<MessageFormType> = async (data) => {
    if (!initSubmit()) return;
    setButtonElem(LOADING_CIRCLE);
    await onSubmit(data);
    if (!finishSubmit(false)) {
      setButtonElem(<IconBug />);
    }
    setButtonElem(<IconCheck />);
    reset();
  };

  return (
    <form
      onSubmit={handleSubmit(submit)}
      className="w-full flex justify-center"
    >
      <div
        className={`group ${loading ? "not-focus-within:glass-blurry" : "not-focus-within:border-base-200"} md:mb-4 flex bg-base-300 items-center w-full px-4 rounded-field overflow-y-scroll`}
      >
        <TextArea<MessageFormType>
          fieldKey="chatMessage"
          placeholder={placeholder || ". . ."}
          className="w-full bg-transparent border-none outline-none resize-none hyphens-auto"
          register={register}
          registerOptions={{ required: true }}
        />
        <Conditional when={loading} show={LOADING_CIRCLE}>
          <button
            type="submit"
            className={`btn btn-ghost btn-circle sticky top-0 ${errors.chatMessage && "btn-disabled"}`}
          >
            <IconSend2 />
          </button>
        </Conditional>
      </div>
    </form>
  );
};
export default MessageForm;
